import {createAction, props} from '@ngrx/store';

export const setSharedLinkId = createAction(
  '[Shared Link] Set Shared Link ID',
  props<{id: string}>(),
);

export const loadSharedLinkData = createAction(
  '[Shared Link] Load Shared Link Data',
  props<{id: string}>(),
);

export const loadSharedLinkDataSuccess = createAction(
  '[Shared Link] Load Shared Link Data Success',
  props<{data: any}>(),
);

export const loadSharedLinkDataFailure = createAction(
  '[Shared Link] Load Shared Link Data Failure',
  props<{error: string}>(),
);

export const setPreviewModeActive = createAction(
  '[Shared Link] Set Preview Mode Active',
);

export const setPreviewModeInactive = createAction(
  '[Shared Link] Set Preview Mode Inactive',
);

export const clearSharedLinkData = createAction(
  '[Shared Link] Clear Shared Link Data',
);
